import { render, staticRenderFns } from "./StockKittingToolReserve.vue?vue&type=template&id=24a03c4b&scoped=true&"
import script from "./StockKittingToolReserve.vue?vue&type=script&lang=js&"
export * from "./StockKittingToolReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a03c4b",
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QItemLabel,QChip,QSeparator} from 'quasar'
component.options.components = Object.assign({QList,QItem,QItemSection,QItemLabel,QChip,QSeparator}, component.options.components || {})
